import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_efy227uud9: FaireBrandEntity = {
  token: "b_efy227uud9",
  type: "brand",
  name: "CICADA",
  avatarUrl:
    "https://cdn.faire.com/fastly/192861b202b1a89e65532429187f69d853c2756adc617d4540291f32b2348ebc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2efbcbbb33828571a71d786bf01f7f61aa43e46fcd2a479744c0e563cbc9cbf4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/192861b202b1a89e65532429187f69d853c2756adc617d4540291f32b2348ebc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2efbcbbb33828571a71d786bf01f7f61aa43e46fcd2a479744c0e563cbc9cbf4.jpeg",
  location: "Tucson, AZ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "CICADA is a Sonoran Desert based fragrance brand that was born from experiences and memories of the landscape. Growing up in this unique landscape, I began capturing the distinct scents of the desert, such as desert rain, at a young age. This passion for natural aromas led to crafting my first candle in 2020, and the company officially launched in 2021. Over the past four years, CICADA has expanded from home fragrances into perfumes. And in August 2026 we are launching an expanded collection that includes memories of coastal, mountains, prairies, riverlands, canyons, and our best-selling desert landscapes fragrances. Our new collections is now available for pre-order and will begin shipping the week of August 17th.\n\nCICADA offers a range of home and body fragrance products, including candles, perfumes, and lotions. Each product is thoughtfully handcrafted to capture the essence of the landscape, with a commitment to craftsmanship.\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:41.866Z",
    importedBy: "entity-db-cli",
  },
};
